import { Metamodel } from '../base/model';
import { IDataFlowExpression } from './interfaces/IDataFlowExpression';

@Metamodel.model({})
export class DataFlowParameterConfig {
    public paramName: IDataFlowExpression;
    public paramValue: IDataFlowExpression;

    public get name(): string {
        return this.paramName.expression;
    }

    public set name(val: string) {
        this.paramName.expression = val;
    }

    public get value(): string {
        return this.paramValue.expression;
    }

    public set value(val: string) {
        this.paramValue.expression = val;
    }

    constructor(name?: IDataFlowExpression, value?: IDataFlowExpression) {
        this.paramName = name;
        this.paramValue = value;
    }
}
